/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

var selected_color_variant = [];
var selected_color_variant_ids = [];

window.onload = function(){
  var reviews_num = $(".nav-tab-sum.yotpo-reviews-nav-tab-sum").text();
  if(reviews_num != ""){
    var nums = reviews_num.replace(/[^0-9]/ig,"");

  $(".toggle-button-reviews").text("Reviews ("+nums+") ")
  }
  

  
  console.log(nums);
  selected_color_variant = [];
  selected_color_variant_ids = [];
  let variant_title = current_variant.title;
  addAddtionalInfo(current_variant)
  console.log(product_options);
  console.log(variant_json);
  console.log(color_name.includes(product_options[0]));
  if( !color_name.includes(product_options[0]) ){
    for(var i in variant_json){
      if(product_options.length > 2){
        if( (variant_json[i].title.includes(current_variant.option1) && variant_json[i].available != false) && (variant_json[i].title.includes(current_variant.option2) && variant_json[i].available != false) ){
             if(!selected_color_variant_ids.includes(variant_json[i].id)){
            selected_color_variant_ids.push(variant_json[i].id);
            selected_color_variant.push(variant_json[i]);
          }
        }
      }else{
        if( (variant_json[i].title.includes(current_variant.option1) && variant_json[i].available != false) ){
             if(!selected_color_variant_ids.includes(variant_json[i].id)){
            selected_color_variant_ids.push(variant_json[i].id);
            selected_color_variant.push(variant_json[i]);
          }
        }
      }
    }

     var variant_swatches_containers = $('.product-form__variants .variant-swatch-list .variant-swatch:not([hidden])');
      console.log(456,selected_color_variant);
      // for(var n in variant_swatches_containers){
      //    console.log(variant_swatches_containers[n]);
      // }
     
      variant_swatches_containers.each(function( index ) {
        var current_color_name = $(this).find("span").text();
        var current_image = $(this).find("img");
        console.log(current_image);
        for(var m in selected_color_variant){
          var real_color = $.trim(selected_color_variant[m].title.split("/").reverse()[0]);
          // console.log(real_color);
          if(real_color == current_color_name){
            current_image.attr("src",selected_color_variant[m].featured_image.src+"&width=120"); 
            current_image.attr("srcset",selected_color_variant[m].featured_image.src+"&width=120"); 
            // current_image.srcset = selected_color_variant[m].featured_image.src+"&width=120";
            console.log(selected_color_variant[m].featured_image.src);
          }
        }
        
      });
    
    // let variant_swatches = document.querySelectorAll('.variant-swatch-list .variant-swatch:not([hidden]) img');
    // if(variant_swatches.length > 0){
    //   for(var j in selected_color_variant){
    //     variant_swatches[j].src = selected_color_variant[j].featured_image.src+"&width=120";
    //     variant_swatches[j].srcset = selected_color_variant[j].featured_image.src+"&width=120";
    //   }
    // }
  }
 
}
document.addEventListener('variant:changed', function(event) {
  let variant = event.detail.variant; // Gives you access to the whole variant details
  let param = event.detail.param;
  var command_new = event.detail.command;
  addAddtionalInfo(event.detail.variant)
  // console.log(command_new);
  // console.log(variant);
  if( command_new == "william"){
    // console.log(param);
    // console.log(variant_json);
    // console.log(color_name);
    if( color_name != "" && !color_name.includes(param) ){
      let form = event.target;
      selected_color_variant = [];
      selected_color_variant_ids = [];
      let variant_title = variant.title;
      
     if(variant.options.length > 2){
          for(var i in variant_json){
              if( (variant_json[i].title.includes(variant.option1) && variant_json[i].available != false) && (variant_json[i].title.includes(variant.option2) && variant_json[i].available != false) ){
                if(!selected_color_variant_ids.includes(variant_json[i].id)){
                  selected_color_variant_ids.push(variant_json[i].id);
                  selected_color_variant.push(variant_json[i]);
                }
              }
           
              
            
          }
       }else{
         for(var i in variant_json){
            console.log(variant_json[i].id);
            if( (variant_json[i].title.includes(variant.option1) && variant_json[i].available != false) ){
              if(!selected_color_variant_ids.includes(variant_json[i].id) ){
                selected_color_variant_ids.push(variant_json[i].id);
                selected_color_variant.push(variant_json[i]);
              }
            }
         }
            
      }
      var variant_swatches_containers = $('.product-form__variants .variant-swatch-list .variant-swatch:not([hidden])');
      console.log(selected_color_variant);
      // for(var n in variant_swatches_containers){
      //    console.log(variant_swatches_containers[n]);
      // }
     
      variant_swatches_containers.each(function( index ) {
        var current_color_name = $(this).find("span").text();
        console.log(current_color_name);
        var current_image = $(this).find("img");
        // console.log(current_image);

        
        for(var m in selected_color_variant){
          var real_color = $.trim(selected_color_variant[m].title.split("/").reverse()[0]);
          // console.log(real_color);
          if(real_color == current_color_name){
            current_image.attr("src",selected_color_variant[m].featured_image.src+"&width=120"); 
            current_image.attr("srcset",selected_color_variant[m].featured_image.src+"&width=120"); 
            // current_image.srcset = selected_color_variant[m].featured_image.src+"&width=120";
            // console.log(selected_color_variant[m].featured_image.src);
          }
        }
        
      });
      
      // console.log(selected_color_variant);
      // let variant_swatches = document.querySelectorAll('.variant-swatch-list .variant-swatch:not([hidden]) img');
      // for(var j in variant_swatches){
      //   variant_swatches[j].src = selected_color_variant[j].featured_image.src+"&width=120";
      //   variant_swatches[j].srcset = selected_color_variant[j].featured_image.src+"&width=120";
      // }
    }
  }
 
  
  
});

function filterByTitle(variants, searchTitle) {
  return variants.filter(function(variant) {
    return variant.title === searchTitle;
  });
}
function addAddtionalInfo(variant){
  $(".delivery_date_new").remove();
   var title = variant.title;
   var filteredVariants = filterByTitle(variantsWithMetafields, title);
   var delivery_date = filteredVariants[0].delivery_date;
   var pre_sale_discount = filteredVariants[0].pre_sale_discount;
   if (delivery_date) {
      // 分离delivery_date字符串
      var parts = delivery_date.split('===');
      if (parts.length === 2) {
        var textToInsert = parts[0]; // 第一部分的字符串
        var elementIndex = parseInt(parts[1], 10) - 1; // 将字符串转换为数字，且减去1以匹配0索引的数组

        // 查找页面中第n个.product-form__option-info元素
        var targetElement = $('.product-form__option-info').eq(elementIndex);
        if (targetElement.length) {
          // 在目标元素中插入span
          targetElement.append('<span class="delivery_date_new">(' + textToInsert + ')</span>');
        }
      }
    }

  
   $(".discount-promo-info").html(pre_sale_discount);
}